import { Paper, styled } from '@mui/material';

const PREFIX = 'SearchInput';

export const classes = {
  root: `${PREFIX}-root`,
  icon: `${PREFIX}-icon`,
  input: `${PREFIX}-input`,
};

export const StyledPaper = styled(Paper)(({ theme }) => ({
  [`&.${classes.root}`]: {
    borderRadius: '4px',
    alignItems: 'center',
    padding: theme.spacing(1),
    display: 'flex',
    flexBasis: 420,
  },

  [`& .${classes.icon}`]: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary,
  },

  [`& .${classes.input}`]: {
    flexGrow: 1,
    fontSize: '14px',
    lineHeight: '16px',
    letterSpacing: '-0.05px',
  },
}));
